<h3 mat-dialog-title>Filtrar Histórico da Custódia</h3>
<div mat-dialog-content style="width: 100%">
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
            <mat-label>Cliente</mat-label>
            <input matInput placeholder="Digite o nome ou conta de um cliente" aria-label="Cliente"  [formControl]="cliente" name="cliente" required [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"  (optionSelected)='getCliente($event.option.value)'>
                <mat-option *ngFor="let cliente of filteredOptions | async" [value]="cliente">
                    <span> {{cliente.nome}}</span> |
                    <small>Conta: {{cliente.numero_xp }}</small>
                </mat-option>
            </mat-autocomplete>
            <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
            <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
        </mat-form-field>
    </div>
    
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
            <mat-label>Ativo</mat-label>
            <input matInput placeholder="Digite o ativo" aria-label="Ativo"  [formControl]="ativo" name="ativo" [matAutocomplete]="auto2">
            <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFnAtivo"  (optionSelected)='getAtivo($event.option.value)'>
                <mat-option *ngFor="let ativo of filteredOptionsAtivo | async" [value]="ativo">
                    <span>Empresa: {{ativo.nome}}</span> |
                    <small>Sigla: {{ativo.sigla }}</small>
                </mat-option>
            </mat-autocomplete>            
            <mat-spinner diameter="20" *ngIf="loadingSpinnerAtivos"></mat-spinner>
        </mat-form-field>
    </div>

    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">

        <mat-form-field appearance="outline" floatLabel="always" fxFlex="1000">
            <mat-label>Arquivos</mat-label>
            <mat-select placeholder="Arquivo"
                        [formControl]="arquivo_id"
                        name="arquivo_id" >
                <mat-option value="">Selecione...</mat-option>
                <mat-option *ngFor="let arquivo of listArquivos" [value]="arquivo.id">{{arquivo.nome_arquivo}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerArquivos"></mat-spinner>
        </mat-form-field>

    </div>

    <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="space-between">
        <mat-form-field 
            appearance="outline" 
            fxLayoutAlign="start" 
            floatLabel="always" 
            fxFlex="45"
        >
            <mat-label>Data da Operação Início</mat-label>
            <input 
                matInput 
                [matDatepicker]="picker" 
                [formControl]="data_operacao_inicio" 
                name="data_operacao_inicio" 
                placeholder="Data da Operação"
            >
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field 
            appearance="outline" 
            fxLayoutAlign="end" 
            floatLabel="always" 
            fxFlex="45"
        >
            <mat-label>Data da Operação Fim</mat-label>
            <input 
                matInput 
                [matDatepicker]="pickerFim" 
                [formControl]="data_operacao_fim" 
                name="data_operacao_fim" 
                placeholder="Data da Operação"
            >
            <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
            <mat-datepicker #pickerFim></mat-datepicker>
        </mat-form-field>
        
    </div>

</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button (click)="filtrar()" tabindex="-1">Filtrar</button>
</div>